import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import Milestones from '../bigProjects/Milestones';

async function action({ store, largeProjectsEnabled }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

  // LARGE PROJECTS FLAG: when OFF this admin LP route is unreachable -> redirect
  // home (mirrors bigProjects/manage-company/index.js; non-LP admin routes untouched).
  if (!largeProjectsEnabled) {
    return { redirect: '/' };
  }

  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }

  return {
    title: 'Milestones — Big Projects',
    component: (
      <AdminLayout>
        <Milestones />
      </AdminLayout>
    ),
  };
}

export default action;
